export const numberRangeCode = "HQ"

// PriceSchemeTypes IDs
export const fromField = 1;
export const dryFromField = 2;

//systemParameters
export const systemParameters = {'YEAROFHARVEST':1}